import React from 'react';
import { bool, func, node, number, string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';

import css from './MainPanelHeader.module.css';
import { isArray } from 'lodash';
import { NamedLink } from '../../../components';

const MainPanelHeader = props => {
  const {
    rootClassName,
    className,
    children,
    sortByComponent,
    isSortByActive,
    listingsAreLoaded,
    resultsCount,
    searchInProgress,
    noResultsInfo,
    urlQueryParams,
    config,
    currentUser,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  const categoryOptions = config.categoryConfiguration.categories;

  const hasCategory =
    isArray(categoryOptions) &&
    categoryOptions.length > 0 &&
    categoryOptions.find(c => c?.id === urlQueryParams?.pub_categoryLevel1);

  return (
    <div className={classes}>
      <div className={css.searchOptions}>
        <div
          className={classNames(css.searchResultSummary, {
            [css.categoryHeading]: hasCategory && !searchInProgress,
          })}
        >
          <span className={css.resultsFound}>
            {searchInProgress ? (
              <FormattedMessage id="MainPanelHeader.loadingResults" />
            ) : hasCategory ? (
              hasCategory.name
            ) : (
              <FormattedMessage
                id="MainPanelHeader.foundResults"
                values={{ count: resultsCount }}
              />
            )}
          </span>
        </div>
        {/* {isSortByActive ? (
          <div className={css.sortyByWrapper}>
            <span className={css.sortyBy}>
              <FormattedMessage id="MainPanelHeader.sortBy" />
            </span>
            {sortByComponent}
          </div>
        ) : null} */}

        {/* {!!currentUser ? <div className={css.sortyByWrapper}>
          <NamedLink
            name="MyHubPage"
            className={css.myHubButton}
          >
            My Hub
          </NamedLink>
        </div>: null} */}
      </div>

      {children}

      {noResultsInfo ? noResultsInfo : null}
    </div>
  );
};

MainPanelHeader.defaultProps = {
  rootClassName: null,
  className: null,
  resultsCount: null,
  searchInProgress: false,
  sortByComponent: null,
};

MainPanelHeader.propTypes = {
  rootClassName: string,
  className: string,
  listingsAreLoaded: bool.isRequired,
  resultsCount: number,
  searchInProgress: bool,
  sortByComponent: node,
};

export default MainPanelHeader;
